import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useImperativeHandle } from 'react';
import { usePolyline } from './usePolyline';
export * from './usePolyline';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    polyline,
    setPath
  } = usePolyline(props);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setPath(props.path), [props.path]);
  useImperativeHandle(ref, () => _extends({}, props, {
    polyline
  }), [polyline, props]);
  return null;
});